import { ForwardOutlined, ArrowRightOutlined, TableOutlined, DeploymentUnitOutlined, GatewayOutlined, LineOutlined, ExperimentOutlined } from "@ant-design/icons"
import { Button, Divider, Space } from "antd"
import { PanelType } from "../RightPanel/types"
import { SetOperations } from "../SetOperations/SetOperations"
import styles from './index.module.less'
import { ReactState } from "../../hooks/useReactState"
import { DrawingMode } from "../../constant"
import { OPermission } from "@/components/OPermission/OPermission"
import { ROLE_CHEMENG, ROLE_DRAFTER } from "@/components/OPermission/PlanPermission"

interface EditorActionsProps {
  rightPanelState: ReactState<PanelType | null>
  drawingMode: ReactState
  onTopologyChange: () => void
  isTemplate: boolean
}
export function EditorActions(props: EditorActionsProps) {
  const { drawingMode, onTopologyChange, isTemplate, rightPanelState} = props;
  const showRightPanel = rightPanelState.value
  const setShowRightPanel = rightPanelState.setValue

  const togglePanel = (type: PanelType) => {
    if (showRightPanel === type) {
      return setShowRightPanel(null);
    }
    setShowRightPanel(type)
  }

  if (isTemplate) {
    return <div className={styles.iconButton}>
      <Button type={showRightPanel === PanelType.Cell ? 'primary' : 'default'} icon={<ForwardOutlined />} onClick={() => togglePanel(PanelType.Cell)}/>
    </div>
  }

  return <Space direction="vertical">
    <OPermission permissions={ROLE_CHEMENG}>
      <div className={styles.iconButton}>
        <Button type={showRightPanel === PanelType.Cell ? 'primary' : 'default'} icon={<ForwardOutlined />} onClick={() => togglePanel(PanelType.Cell)} />
      </div>
    </OPermission>
    
    <OPermission permissions={ROLE_DRAFTER}>
      <div className={styles.iconButton}>
        <Button
          type={showRightPanel === PanelType.Graph ? 'primary' : 'default'}
          icon={<GatewayOutlined />}
          onClick={() => {
            togglePanel(PanelType.Graph)
          }}
        />
      </div>
    </OPermission>
    
    <Divider className={styles.divider} />
    <OPermission permissions={ROLE_CHEMENG}>
      <div className={styles.iconButton}>
        <Button type={showRightPanel === PanelType.Spreadsheet ? 'primary' : 'default'} icon={<TableOutlined />}
          onClick={
            () => {
              togglePanel(PanelType.Spreadsheet)
            }
          } />
      </div>
    </OPermission>
    
    <OPermission permissions={ROLE_DRAFTER}>
      <div className={styles.iconButton}>
        <Button
          type={showRightPanel === PanelType.AllUnits ? 'primary' : 'default'}
          icon={<DeploymentUnitOutlined />}
          onClick={() => {
            togglePanel(PanelType.AllUnits)
          }}
          />
      </div>
    </OPermission>
    
    <OPermission permissions={ROLE_CHEMENG}>
      <div className={styles.iconButton}>
        <Button
          type={showRightPanel === PanelType.PPST ? 'primary' : 'default'}
          icon={<ExperimentOutlined />}
          onClick={() => {
            togglePanel(PanelType.PPST)
          }}
          />
      </div>
    </OPermission>
    
    
    <OPermission permissions={ROLE_DRAFTER}>
      <Divider className={styles.divider} />
      <div className={styles.iconButton}>
        <Button type={drawingMode.value === DrawingMode.Stream ? 'primary' : 'default'} icon={<ArrowRightOutlined />}
        onClick={() => drawingMode.setValue(drawingMode.value !== DrawingMode.Stream ? DrawingMode.Stream : DrawingMode.None)} />
      </div>
      <div className={styles.iconButton}>
        <Button
          type={drawingMode.value === DrawingMode.Line ? 'primary' : 'default'} 
          icon={<LineOutlined />}
          onClick={() => drawingMode.setValue(drawingMode.value !== DrawingMode.Line ? DrawingMode.Line : DrawingMode.None)}
        />
      </div>
    </OPermission>
    
    <OPermission permissions={ROLE_CHEMENG}>
      <Divider className={styles.divider} />
      <SetOperations className={styles.iconButton} onChange={onTopologyChange} />
    </OPermission>
    

  </Space>
}